import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en/translations';
import frTranslations from './locales/fr/translations';

const DEFAULT_LANGUAGE = 'en-GB';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupQuerystring: 'lng',
      order: ['localStorage', 'navigator', 'htmlTag', 'path'],
    },
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      [DEFAULT_LANGUAGE]: {
        translation: enTranslations,
      },
      fr: {
        translation: frTranslations,
      },
    },
    supportedLngs: [DEFAULT_LANGUAGE],
  });

export { i18n };
export type { TFunction } from 'i18next';
